import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import NYCFooter from './NYCFooter';
import TorontoFooter from './TorontoFooter';

class GeneralFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { history, operatingCity, loggedIn } = this.props;
    const { pathname } = history.location;
    if (['/nyc/faq'].includes(pathname) || operatingCity === 'new_york') {
      return <NYCFooter />;
    } else if (
      ['/faq'].includes(pathname) ||
      operatingCity === 'toronto'
    ) {
      return <TorontoFooter />;
    } else {
      return null;
    }
  }
}

export default withRouter(GeneralFooter);



// WEBPACK FOOTER //
// ./src/components/Layout/GeneralFooter.js